var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgImage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "#191818",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.33333 4C6.9066 4 5.75 5.1566 5.75 6.58333C5.75 8.01007 6.9066 9.16667 8.33333 9.16667C9.76007 9.16667 10.9167 8.01007 10.9167 6.58333C10.9167 5.1566 9.76007 4 8.33333 4ZM7.25 6.58333C7.25 5.98502 7.73502 5.5 8.33333 5.5C8.93164 5.5 9.41667 5.98502 9.41667 6.58333C9.41667 7.18164 8.93164 7.66667 8.33333 7.66667C7.73502 7.66667 7.25 7.18164 7.25 6.58333Z",
    fill: "current",
    fillOpacity: "current"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.25 5C0.25 2.37665 2.37665 0.25 5 0.25H17C19.6234 0.25 21.75 2.37665 21.75 5V18.6178C21.75 20.3477 20.3477 21.75 18.6178 21.75C18.2036 21.75 17.8678 21.4142 17.8678 21C17.8678 20.5858 18.2036 20.25 18.6178 20.25C19.5192 20.25 20.25 19.5192 20.25 18.6178V15.9973L15.4479 10.1719L9.55709 17.1723C9.42017 17.335 9.22063 17.4319 9.00811 17.439C8.79558 17.446 8.59005 17.3625 8.44265 17.2093L5.337 13.98L3.56002 16.1973C3.55378 16.205 3.54738 16.2127 3.54083 16.2202L1.93104 18.0723C2.37406 19.3403 3.58079 20.25 5 20.25H13.7274C14.1416 20.25 14.4774 20.5858 14.4774 21C14.4774 21.4142 14.1416 21.75 13.7274 21.75H5C2.37664 21.75 0.25 19.6234 0.25 17V5ZM20.25 5V13.6391L16.0326 8.52294C15.891 8.35114 15.6803 8.25114 15.4577 8.25001C15.235 8.24888 15.0234 8.34674 14.88 8.5171L8.94604 15.5687L5.8263 12.3248C5.67673 12.1693 5.46743 12.0857 5.25188 12.0955C5.03633 12.1052 4.83542 12.2073 4.70048 12.3757L2.39891 15.2475L1.75 15.994V5C1.75 3.20507 3.20507 1.75 5 1.75H17C18.7949 1.75 20.25 3.20507 20.25 5Z",
    fill: "current",
    fillOpacity: "current"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImage);
export default __webpack_public_path__ + "static/media/image.6bd27e7fe7dc28fea3494e9df7bd42d1.svg";
export { ForwardRef as ReactComponent };